import React from 'react'
import {widgetDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useAdditionalItemsToggle} from '../../../hooks/use-additional-items-toggle'
import {CardContainerProps} from './interfaces'
import s from './card-container.scss'

export const CardContainer = ({event, children, stripWidth, lastItem}: CardContainerProps) => {
  const {hovered, events} = useAdditionalItemsToggle({event})

  return (
    <li style={{marginBottom: lastItem ? 0 : stripWidth}} {...events} data-hook={DH.listItem} className={s.container}>
      {children(hovered)}
    </li>
  )
}
